import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import {
  ApiHelpArticleViewSave,
  ApiHelpFeedback,
  ApiHelpFeedbackCommentSave,
  ApiHelpFeedbackRatingSave,
} from "@/types/help-feedback.types.ts";

export const apiHelpFeedback = {
  saveRating: async (payload: ApiHelpFeedbackRatingSave) => {
    return api.put<ApiHelpFeedback>("/api/v1/help/feedbacks/rating", payload);
  },
  saveComment: async (payload: ApiHelpFeedbackCommentSave) => {
    return api.put<ApiHelpFeedback>("/api/v1/help/feedbacks/comment", payload);
  },
  registerView: async (payload: ApiHelpArticleViewSave) => {
    return api.post<ApiOperationResult>("/api/v1/help/views", payload);
  },
};
